/*
* @Author: Wang Shuai
* @Date:   2022-09-05 14:15:41
* @Last Modified by:   Wang
* @Last Modified time: 2022-09-05 14:29:53
*/

// 投资计算接口管理
import request from '../request.js'

// 获取编码分类码表 --- 崔北超
export const getNodeInfo = function (data) {
    return request({
        url: '/busProjectInvestmentComposition/getNodeInfo',
        method: 'post',
        data
    })
}

// 保存项目投资构成 --- 崔北超
export const saveInvest = function (data) {
    return request({
        url: '/busProjectInvestmentComposition/saveProjectInvestmentComposition',
        method: 'post',
        data
    })
}